import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import React, { useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';

import { ILocationDropdownProps } from '@/modules/periodicJobs/components/LocationDropdown/ILocationDropdown.d';
import LocationItem from '@/modules/periodicJobs/components/LocationDropdown/LocationItem';
import { PeriodicJobsContext } from '@/modules/periodicJobs/context/context';
import { periodicJobsActionsTypes as ActionsTypes } from '@/modules/periodicJobs/context/reducer';
import { IPeriodicJobs } from '@/modules/periodicJobs/types';
import { Button, Loading, Typography } from '@/shared/components/atoms';

import Check from '~/images/shared/CheckWithoudBg.svg';

const LocationDropdown: React.FC<ILocationDropdownProps> = ({
  plots,
  hasMore,
  loadMore,
  onConfirm,
}) => {
  const { t, i18n } = useTranslation('common');

  const isAr = i18n.language === 'ar';

  const classNames = clsx(
    isAr ? 'right-16' : 'left-16',
    'h-290 w-343',
    'flex flex-col',
    'absolute top-56 z-50',
    ' bg-primary-99 p-16',
    'rounded-xl border-xs border-primary-600'
  );

  const [selectedPlots, setSelectedPlots] = useState<IPeriodicJobs.Plot[]>([]);

  const { state, dispatch } = useContext(PeriodicJobsContext);

  const selectPlotHandler = (plot: IPeriodicJobs.PlotSchema) => {
    const index = selectedPlots.lastIndexOf(plot);

    if (index === -1) {
      setSelectedPlots((prevPlots) => prevPlots.concat(plot));
    } else {
      setSelectedPlots((prevPlots) =>
        prevPlots.filter((p) => p.id !== plot.id)
      );
    }
  };

  const confirmPlotsHandler = () => {
    dispatch({ type: ActionsTypes.setPlots, payload: selectedPlots });
    onConfirm();
  };

  useEffect(() => {
    if (state.selectedPlots.length) {
      setSelectedPlots(state.selectedPlots);
    }
  }, [state.selectedPlots]);

  return (
    <div className={classNames}>
      <Typography weight='bold' className='mb-12 text-start text-base'>
        {t('work-locations')}
      </Typography>
      {/*REFERENCE: Infinite scroll component*/}
      <InfiniteScroll
        hasMore={hasMore}
        loadMore={loadMore}
        loader={<Loading />}
        className='scrollbar-track-gray-200 flex max-h-full w-full flex-auto flex-col gap-y-2 overflow-y-auto scrollbar-thin scrollbar-thumb-background-200'
      >
        {plots?.map((plot) => (
          <LocationItem
            key={plot.id}
            selected={selectedPlots.includes(plot)}
            onClick={() => selectPlotHandler(plot)}
          >
            {t('plot')} {plot.number}
          </LocationItem>
        ))}
      </InfiniteScroll>
      <Button
        size='full'
        className='mt-16 rounded-xl py-8 capitalize'
        onClick={confirmPlotsHandler}
      >
        <span className='flex items-center justify-center gap-x-8'>
          {t('confirm')} <Check />
        </span>
      </Button>
    </div>
  );
};

export default LocationDropdown;
